// extracted by mini-css-extract-plugin
export default {"progress":"style_progress__lHacm","defaultProgress":"style_defaultProgress__b+4jK"};